import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import supplierService from "../Services/supplierService";
import Loading from "../Modals/Loading";
import Head from "../Components/Head";

const SupplierPayments = () => {
  const navigate = useNavigate();
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getSuppliers = async () => {
      setLoading(true);
      try {
        const res = await supplierService.fetchPayments();
        setPayments(res.suppliers);
      } catch (err) {
        console.error("Error fetching payments:", err);
      } finally {
        setLoading(false);
      }
    };
    getSuppliers();
  }, []);

  const totalAmount = payments.reduce(
    (total, payment) => total + parseFloat(payment.amount || 0),
    0,
  );

  return (
    <div className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      {loading ? (
        <div className="flex justify-center items-center">
          <Loading />
        </div>
      ) : (
        <div>
          <Head
            heading={"Supplier Payments"}
            button_text={"Add Supplier Payments"}
            navigation={() => navigate("/supplierpayments/add")}
          />

          <div className="table-div">
            <table>
              <thead>
                <tr className="border-y-2 text-left w-full text-black text-[10px]">
                  <th className="py-4 w-[2%]">Sr No.</th>
                  <th className="py-4 w-[2%]">Date</th>
                  <th className="py-4 w-[3%]">Voucher</th>
                  <th className="py-4 w-[3%]">Company</th>
                  <th className="py-4 w-[2%]">Amount</th>
                  <th className="py-4 w-[2%]">Payment Method</th>
                  <th className="py-4 w-[2%]">Transaction Type</th>
                  <th className="rounded-tr-xl py-4 w-[3%]">Note</th>
                </tr>
              </thead>
              <tbody>
                {payments?.map((payment, index) => (
                  <tr
                    key={index}
                    className="bg-accent border-b border-gray-100 text-left"
                  >
                    <td className="py-3 w-[2%] font-bold text-blue-500">
                      {index + 1}
                    </td>
                    <td className="py-3 w-[3%] font-semibold">
                      {payment.date ? payment.date.slice(0, 10) : "N/A"}
                    </td>
                    <td className="py-3 w-[3%] pr-3">
                      {payment.voucher}-{payment.voucher_id}
                    </td>
                    <td className="py-3 w-[3%] font-semibold text-sky-600 pr-3">
                      {payment.company}
                    </td>
                    <td className="py-3 w-[2%] font-semibold text-teal-600">
                      {payment.amount} AED
                    </td>
                    <td className="py-3 w-[2%]">{payment.payment_method}</td>
                    <td className="py-3 w-[2%]">{payment.transaction_type}</td>
                    <td className="py-3 w-[3%] font-semibold text-[10px]">
                      {payment.note}
                    </td>
                  </tr>
                ))}

                <tr className="bg-gray-100 font-bold text-left">
                  <td className="pl-4 py-3 text-left" colSpan="4">
                    Total
                  </td>
                  <td className="py-3 font-bold text-teal-600" colSpan="4">
                    {totalAmount.toFixed(2)} AED
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default SupplierPayments;
